import { membersBaseURL } from "@/functions/helpers";

const baseURL = membersBaseURL();

const _post = (url, params, config = {}) =>
  window.axios.post(url, params, { baseURL, ...config });
const _put = (url, params) => window.axios.put(url, params, { baseURL });
const _delete = url => window.axios.delete(url, { baseURL });
const _get = (url, config) => window.axios.get(url, { baseURL, ...config });

export default {
  getAll(context, { product_id, params }) {
    return new Promise((resolve, reject) => {
      const config = params.type === "excel" ? { responseType: "blob" } : null;
      const queryString = new URLSearchParams(params).toString();
      return _get(`/accounts/students/${product_id}?${queryString}`, config)
        .then(response => {
          if (response.data.results) {
            context.commit("setStudents", response.data.results);
            context.commit("setPagination", response.data);
          }
          resolve(response);
        })
        .catch(reject);
    });
  },
  getDetails(context, id) {
    return new Promise((resolve, reject) => {
      _get(`/accounts/students/${id}/edit`)
        .then(({ data }) => {
          context.commit("setStudent", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  getProgressDetails(context, { product_id, student_id }) {
    return new Promise((resolve, reject) => {
      _get(`/modules/progress/detail/${product_id}?user_id=${student_id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  put(context, params) {
    return new Promise((resolve, reject) => {
      _put(`/accounts/students/${params.id}/edit`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  post(context, params) {
    return new Promise((resolve, reject) => {
      _post(`/accounts/students/${params.product_id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  importCSV(context, params) {
    return new Promise((resolve, reject) => {
      _post(`/accounts/students/import-data/${params.product_id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  lastImport(context, id) {
    return new Promise((resolve, reject) => {
      _get(`/accounts/students/last-import/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  enable(context, id) {
    return new Promise((resolve, reject) => {
      _get(`/accounts/students/${id}/enable`)
        .then(resolve)
        .catch(reject);
    });
  },
  disable(context, id) {
    return new Promise((resolve, reject) => {
      _get(`/accounts/students/${id}/disable`)
        .then(resolve)
        .catch(reject);
    });
  },
  changePassword(context, params) {
    return new Promise((resolve, reject) => {
      _put(`/accounts/students/change-password/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  resetPassword(context, params) {
    return new Promise((resolve, reject) => {
      _post(`/accounts/students/reset-password/${params.student_id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },

  disableSubscription(context, params) {
    const { email, product_id } = params;
    return new Promise((resolve, reject) => {
      _post(`/accounts/students/${product_id}/disable`, { email })
        .then(resolve)
        .catch(reject);
    });
  }
};
